module.exports = __webpack_public_path__ + "static/media/art-collections-icon.6dd433ef.svg";